"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncService = void 0;
const service_1 = require("./service");
const mapper_1 = require("../utils/mapper");
class SyncService extends service_1.Service {
    constructor(transport, auth) {
        super(transport, auth);
    }
    /**
     * Get unread counts and items.
     * Command: "mn" (UNREAD_COUNT) - 28269
     * @param version Last sync version (timestamp). Use 0 for full sync.
     */
    async getUnread(version = 0) {
        const response = await this.transport.send('mn', [version, 0, 0]);
        this.checkError(response, 'mn');
        const data = response.data;
        return {
            version: data[0],
            qmsCount: data[1],
            favCount: data[2],
            mentionCount: data[3],
            items: (data[4] || []).map(item => ({
                type: item[0],
                id: item[1],
                title: item[2],
                authorId: item[3],
                authorName: item[4],
                lastPostTs: mapper_1.PdaMapper.safeIsoDate(item[5]),
                myLastReadTs: mapper_1.PdaMapper.safeIsoDate(item[6])
            }))
        };
    }
    /**
     * Сброс счётчика непрочитанного (прочтение диалога, упоминания или темы избранного).
     * Command: "mn" — `[0, <Type>, <ID>]`, Type: 1 QMS, 2 Упоминание, 3 Избранное.
     */
    async markAsRead(type, id) {
        const response = await this.transport.send('mn', [0, type, id]);
        this.checkError(response, 'mn');
    }
}
exports.SyncService = SyncService;
